module.exports = __webpack_public_path__ + "static/img/naturally-nav.1cd5a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/naturally-nav.png
// module id = VexN
// module chunks = 4